import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function Instagram(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      hoverColor = _ref.hoverColor,
      testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M17.16 4c2.224.004 2.678.021 3.788.071 1.276.059 2.15.262 2.913.558a5.883 5.883 0 012.124 1.385 5.886 5.886 0 011.385 2.125c.297.763.5 1.636.558 2.913.054 1.195.07 1.63.072 4.333v1.23c-.002 2.702-.018 3.138-.072 4.332-.058 1.278-.261 2.151-.558 2.913a5.89 5.89 0 01-1.385 2.126 5.893 5.893 0 01-2.124 1.384c-.764.297-1.637.5-2.913.558-1.195.054-1.63.07-4.334.072h-1.228c-2.704-.002-3.14-.018-4.334-.072-1.277-.058-2.15-.261-2.913-.558a5.888 5.888 0 01-2.125-1.384A5.873 5.873 0 014.63 23.86c-.297-.762-.5-1.635-.558-2.913-.051-1.109-.068-1.563-.072-3.787v-2.321c.004-2.223.021-2.678.072-3.787.058-1.277.261-2.15.558-2.913a5.87 5.87 0 011.384-2.125 5.878 5.878 0 012.125-1.385c.764-.296 1.636-.499 2.913-.558 1.11-.05 1.564-.067 3.788-.071h2.32zm-.28 2.162h-1.76c-2.41.003-2.83.018-3.97.069-1.17.054-1.804.249-2.227.414-.56.217-.96.478-1.38.897-.42.42-.68.82-.898 1.38-.164.423-.36 1.058-.413 2.228-.052 1.14-.067 1.561-.07 3.97v1.76c.003 2.409.018 2.83.07 3.969.053 1.171.249 1.805.413 2.228.218.561.478.96.897 1.38.42.42.82.68 1.38.897.424.166 1.058.361 2.228.415 1.098.049 1.529.065 3.71.068h2.28c2.181-.003 2.612-.019 3.71-.068 1.168-.054 1.804-.249 2.227-.415.56-.217.96-.477 1.38-.897.42-.42.68-.819.897-1.38.164-.423.36-1.057.413-2.228.05-1.097.067-1.528.07-3.709v-2.28c-.003-2.181-.02-2.613-.07-3.71-.053-1.17-.249-1.805-.413-2.228a3.71 3.71 0 00-.897-1.38 3.72 3.72 0 00-1.38-.897c-.423-.165-1.059-.36-2.227-.414-1.14-.051-1.56-.066-3.97-.069zM16 9.837a6.162 6.162 0 110 12.325 6.162 6.162 0 010-12.325zM16 12a4 4 0 100 8 4 4 0 000-8zm6.405-3.846a1.44 1.44 0 110 2.881 1.44 1.44 0 010-2.881z",
    fillRule: "evenodd"
  }));
}

Instagram.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default Instagram;